import styled, { css } from "styled-components";

interface Iprops {
    expanded: boolean | number;
    width: number;
}

export const Container = styled.div`
  display: flex;
  height: 100vh;
  border: solid 0px #b9080f !important;
`;

export const ContainerMain = styled.main`
  border: solid 0px #5a28ff !important;
  background: none !important;
  flex-grow: 1;
  padding: 0px;
  margin-right:10px;
  margin-left: ${({ width }: Iprops) => width}px;
  ${({ expanded }: Iprops) =>
      expanded &&
      css`
      transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
        margin-left 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;
      margin-left: 70px !important;
    `};

  @media (min-width: 0px) and (orientation: landscape) {
    margin-top: 48px;
  }

  @media (min-width: 600px) {
    margin-top: 64px;
  }
`;
